'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of add supps mobile
 */ const AddSuppsMobile = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.0312",
                y: "68.6562",
                width: "17.5976",
                height: "5.22701",
                rx: "1.61817",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.5238 18.4727H63.0198C64.6541 18.4817 66.2186 19.136 67.3726 20.2931C68.5266 21.4502 69.1767 23.0163 69.1812 24.6504V78.5429C69.1767 80.18 68.5242 81.7487 67.3665 82.9062C66.2088 84.0638 64.6399 84.7162 63.0026 84.7207H40.5067C38.8694 84.7162 37.3005 84.0638 36.1428 82.9062C34.9851 81.7487 34.3327 80.18 34.3281 78.5429V66.6893V59.0603V57.1867V24.6504C34.3327 23.0104 34.9874 21.4391 36.1489 20.281C37.3103 19.123 38.8836 18.4726 40.5238 18.4727Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3916 68.7461H45.1506C43.7406 68.7461 42.5977 69.8889 42.5977 71.2987C42.5977 72.7085 43.7406 73.8513 45.1506 73.8513H58.3916C59.8015 73.8513 60.9445 72.7085 60.9445 71.2987C60.9445 69.8889 59.8015 68.7461 58.3916 68.7461Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.8555",
                y: "73.8359",
                width: "6.04773",
                height: "5.91334",
                rx: "2.95667",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.0312",
                y: "21.418",
                width: "29.7011",
                height: "48.9194",
                rx: "1.98447",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.0725 39.7637V37.8079C57.8502 37.8079 58.4806 37.1774 58.4806 36.3997V35.894C58.4806 34.9062 57.6799 34.1055 56.6921 34.1055H47.3645C46.3768 34.1055 45.576 34.9062 45.576 35.894V36.3997C45.576 37.1774 46.2065 37.8079 46.9841 37.8079V39.7926C46.2115 40.0748 45.5451 40.5824 45.0746 41.2473C44.604 41.9122 44.3517 42.7026 44.3516 43.5124V55.8317C44.3516 56.8194 45.1523 57.6202 46.1401 57.6202H58.0017C58.9894 57.6202 59.7902 56.8194 59.7902 55.8317V43.5142C59.7901 42.6891 59.5284 41.8846 59.0413 41.2124C58.5543 40.5402 57.8661 40.0339 57.0725 39.7637Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45.3281",
                y: "34.0977",
                width: "13.3333",
                height: "3.78947",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "58.3799",
                cy: "44.7471",
                r: "3.50877",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("line", {
                x1: "58.3494",
                y1: "42.9705",
                x2: "58.3494",
                y2: "46.5465",
                stroke: "#F5FAFF",
                strokeWidth: "0.941071",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("line", {
                x1: "60.1818",
                y1: "44.7889",
                x2: "56.6059",
                y2: "44.7889",
                stroke: "#F5FAFF",
                strokeWidth: "0.941071",
                strokeLinecap: "round"
            })
        ]
    });
};

exports.AddSuppsMobile = AddSuppsMobile;
//# sourceMappingURL=AddSuppsMobile.cjs.map
